import ReactDOMClient from 'react-dom/client';

import { App } from './app';

const appContainer = document.createElement('div');
document.body.appendChild(appContainer);

ReactDOMClient.createRoot(appContainer).render(<App />);
